import { React, useState } from "react";
import Filter from "./Filter";
import foodData from "./FoodData";
import SignUpForm from "./SignupForm";
import { Link, NavLink, Route, Routes } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faLocationDot, faUser } from "@fortawesome/free-solid-svg-icons";
import "./Navbar.css";



const Navbar = ({ search, searchHandler,searchHandlerOnClick }) => {

  const zomatoLogo =
    "https://b.zmtcdn.com/web_assets/b40b97e677bc7b2ca77c58c61db266fe1603954218.png";
  const deliveryImg =
    "https://b.zmtcdn.com/data/o2_assets/c0bb85d3a6347b2ec070a8db694588261616149578.png?output-format=webp";
  const dinnerImg =
    "https://b.zmtcdn.com/data/o2_assets/78d25215ff4c1299578ed36eefd5f39d1616149985.png?output-format=webp";

  const [signUpShow, setSignUpShow] = useState(false);
 
  const signUpFormHandler = () => {
    setSignUpShow(previous => !previous)
  }
 

  return (
    <>
      <div className="container">
        <div className="row">
          <header className="wrapper d-flex justify-evenly" >
            <div className="logo col-2 d-flex justify-between align-items-center">
              <img src={zomatoLogo} alt="zamoto" />
            </div>

            <div className="search-bar  mt-2 col-6 d-flex">
              <FontAwesomeIcon
                className="icon-nav location-icon"
                icon={faLocationDot}
                style={{ color: "#db1a23" }}
              />
              <input
                type="text"
                className="search-location"
                placeholder="old city Ahmedabad"
              />
              <FontAwesomeIcon
                className="icon-nav"
                icon={faMagnifyingGlass}
                style={{ color: "#04091b" }}
                onClick={searchHandlerOnClick}
              />
              <input
                type="text"
                className="search-input"
                value={search}
                onChange={searchHandler}
                placeholder="Search for restaurent or food"
              />
            </div>
            <div className="user-icon">
              <FontAwesomeIcon
                className="icon-user"
                icon={faUser}
                style={{ color: "#FF0000" }}
              />

            </div>

            <div className="btns-container col-3 d-flex">
              <button onClick={signUpFormHandler} className="btn btn-1">Sign Up</button>
              <button className="btn btn-2">Login In</button>
            </div>
            {signUpShow && <SignUpForm />}
          </header>

          <div className="mobile-search-bar hide">
          <div className="mobile-search-bar d-flex align-items-center justify-content-between">
            <input
              type="text"
              className="search-mobile"
              value={search}
              onChange={searchHandler}
              placeholder="Search for restaurent or food"
            />
            <button  className="search-icon-mobile-btn">
            <FontAwesomeIcon
              className="search-icon-mobile"
              icon={faMagnifyingGlass}
              style={{ color: "#04091b" }}
              onClick={searchHandlerOnClick}
              />
              </button>
          </div>
          </div>
          <div className="link-conatiner mt-3">
            <ul className="p-0">
              <li className="col-12 d-flex justify-between align-center">
                <Link to="/">Home</Link>
                <Link to="/">india</Link>
                <Link to="/">Ahmedabad</Link>
                <Link to="/">Central Ahmedabad</Link>
                <Link to="/">Jamnagar</Link>
              </li>
            </ul>
          </div>
          <div className="food-time col-lg-6 col-md-6 d-flex justify-between align-center">
            <div
              className="delivery-items menu bg-color"
              style={{ backgroundColor: "rgb(252, 238, 192)" }}
            >
              <img src={deliveryImg} alt="" />
            </div>

            <NavLink className="delivery btn-food" activeClassName="active" to="/">
              Delivery
            </NavLink>
            <div
              className="dinner-items menu bg-color"
              style={{ backgroundColor: "rgb(248, 248, 248)" }}
            >
              <img src={dinnerImg} alt="" />
            </div>
            <NavLink className="dining btn-food" activeClassName="active" to="/restaurent">
              Dining Out
            </NavLink>
          </div>
        </div>
      </div>
      <hr className="container-fluid mt-3 mb-0" />
      <Filter />
    </>
  );
};

export default Navbar;
